import React, {
	// useContext
}
from 'react';
// import {Box} from '@material-ui/core';
// import {makeStyles} from '@material-ui/core/styles';
import { Link } from '@mui/material';
import { KoalyResponsiveLogo } from '../../../modules/hp/common/Logo/LoghiKoaly';
// import AppContext from '../../../@crema/utility/AppContext';
// import {ThemeMode} from '../../constants/AppEnums';
// import Hidden from '@material-ui/core/Hidden';
// import AppContextPropsType from '../../../types/AppContextPropsType';

const AppLogo: React.FC<{}> = (_) => {
	// const {themeMode} = useContext<AppContextPropsType>(AppContext);
	// const useStyles = makeStyles(() => ({
	// 	logoRoot: {
	// 		display: 'flex',
	// 		flexDirection: 'row',
	// 		cursor: 'pointer',
	// 		alignItems: 'center',
	// 		flexShrink: 0,
	// 	},
	// 	logo: {
	// 		height: 36,
	// 		marginRight: 10,
	// 	},
	// }));
	// const classes = useStyles();
	//const logoSrc = themeMode === ThemeMode.DARK ? '/assets/images/logo-white.png' : '/assets/images/logo.png'
	// const logoSrc = '/koaly_logo.png';
	return (
		// <Box className={classes.logoRoot}>
		// 	<Hidden smUp>
		// 		<img className={classes.logo} src={logoSrc} alt='app-logo'/>
		// 	</Hidden>
		// 	<Hidden xsDown>
		// 		<img className={classes.logo} src={logoSrc} alt='app-logo'/>
		// 	</Hidden>
		// </Box>
		<Link href='/Home'
			draggable={false}
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			{/* <Box className={classes.logoRoot} >
				<img className={classes.logo} src={logoSrc} alt='app-logo'/>
			</Box> */}
			<KoalyResponsiveLogo />
		</Link>
	);
};

export default AppLogo;
